import { useDispatch } from "react-redux";
import { CmmOrderTableRowData } from "../../../../data-model/cmmOrderTableRowData";

import { setOpenedModalId } from "../../../../redux/slice/modalSliceNew";
import { AppDispatch } from "../../../../redux/store/store";
import EyeIcon from "../../../../svg/eye";
import IcdDescriptionTooltip from "./IcdDescriptionTooltip";

interface InternalChildCardProps {
  title: string;
  showPrimaryDescription?: boolean;
  primaryDescription: string[];
  secondaryDescription: string[];
  showIcon?: boolean;
  isPrimaryInformation?: boolean;
  width?: string;
  modalId?: string;
  rowData?: CmmOrderTableRowData;
  showIcdDescriptionTooltip?: boolean;
  icdCode?: string;
}

const InternalChildCard = ({
  title,
  showPrimaryDescription,
  primaryDescription,
  secondaryDescription,
  showIcon,
  isPrimaryInformation,
  width,
  modalId,
  rowData,
  showIcdDescriptionTooltip,
  icdCode,
}: InternalChildCardProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const handleEyeIconClick = () => {
    if (modalId) {
      dispatch(setOpenedModalId({ id: modalId }));
    }
  };

  return (
    <div className={`"w-1/4"} flex flex-col gap-2 p-3`}>
      <div className="flex flex-col gap-1 text-sm">
        <div className="flex flex-row items-center gap-2">
          <div className="font-bold">{title}</div>

          {showIcon && <EyeIcon onClick={handleEyeIconClick} />}
        </div>
        {showPrimaryDescription && (
          <div
            className={`text-primaryGray-6 ${!isPrimaryInformation ? "max-w-[20ch] truncate" : ""}`}
            title={primaryDescription.join(" - ")}
            dangerouslySetInnerHTML={{
              __html: primaryDescription.join(" &#8226; "),
            }}
          />
        )}
      </div>
      <div className="flex items-center gap-1">
        <div
          className="max-w-[50ch] truncate text-sm"
          title={secondaryDescription.slice(0, 3).join(" - ")}
          dangerouslySetInnerHTML={{
            __html:
              title === "Dosage"
                ? secondaryDescription.join(" ")
                : secondaryDescription.join(" &#8226; "),
          }}
        />
        {showIcdDescriptionTooltip && icdCode && (
          <IcdDescriptionTooltip icdCode={icdCode} />
        )}
      </div>
    </div>
  );
};

export default InternalChildCard;
